import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
// import AudioRecorder from 'react-audio-recorder';
import AudioRecorder from '../../../../utils/react-audio-recorder-fixed/AudioRecorder';
import Loading from '../../Loading';
import { sendMessage, uploadMessageImage } from '../../../../utils/Api';

class Voice extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.onChange = this.onChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.send = this.send.bind(this);
  }

  getInitialState() {
    return {
      isShowed: false,
      audioData: null,
      isLoaded: true,
    };
  }

  onChange({ audioData }) {
    this.setState({ audioData });
  }

  toggle() {
    const { isShowed } = this.state;
    this.setState(isShowed
      ? this.getInitialState()
      : { isShowed: true });
  }

  send() {
    const { audioData } = this.state;
    this.setState({ isLoaded: false });
    uploadMessageImage(audioData).then(({ id, error }) => {
      const { chatId, onAddComplete, intl } = this.props;
      if (!error) {
        sendMessage(chatId, { storage_id: id }).then((res) => {
          if (!res.error) {
            this.setState(this.getInitialState());
            onAddComplete();
          } else {
            const message = res.error.code ? `error_code_${res.error.code}` : res.error.msg;
            alert(intl.formatMessage({ id: message }) || 'error sending message');
            this.setState(this.getInitialState());
          }
        });
      } else {
        const message = error.code ? `error_code_${error.code}` : error.msg;
        alert(intl.formatMessage({ id: message }) || 'error uploading audio');
        this.setState(this.getInitialState());
      }
    });
  }

  render() {
    const { isShowed, audioData, isLoaded } = this.state;
    const { intl } = this.props;

    return (
      <React.Fragment>
        <Button
          color="secondary"
          className="mrg-r-md mrg-t-md"
          onClick={this.toggle}
        ><FormattedMessage id="messages_recordVoice" /></Button>
        <Modal isOpen={isShowed} toggle={this.toggle} className="modal-lg">
          {!isLoaded && <Loading />}
          <ModalHeader toggle={this.toggle}><FormattedMessage id="messages_recordAudioMessage" /></ModalHeader>
          <ModalBody style={{ textAlign: 'center' }}>
            <AudioRecorder
              className="btn btn-secondary mrg-r-md mrg-t-md"
              recordLabel={intl.formatMessage({ id: 'messages_record' })}
              recordingLabel={intl.formatMessage({ id: 'messages_recording' })}
              removeLabel={intl.formatMessage({ id: 'overall_input_remove' })}
              downloadable={false}
              onChange={this.onChange}
            />{audioData && (
              <Button
                color="secondary"
                type="submit"
                onClick={this.send}
                className="text-hide mrg-l-md mrg-t-md button_send_message"
              >
                <i className="icon_c icon_c_bg icon_send_message b-0" />
                {/* <FormattedMessage id="overall_input_send" /> */}
              </Button>)}
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

Voice.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  chatId: PropTypes.number.isRequired,
  onAddComplete: PropTypes.func.isRequired,
};

export default injectIntl(Voice);



// WEBPACK FOOTER //
// ./src/views/_Chats/Messages/New/Voice.js